// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610091953/js/" + chunkId + "." + {"44":"059e074a","225":"792e2fd6","481":"01fc887c","486":"ce01ccb2","770":"6b7fc48c"}[chunkId] + ".0.07453698946412446.chunk.js";
};